import React from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';

const CustomCheckbox = ({ onChange, checked, name, label, className = 'field-component' }) => (
  <Box component="section">
    <FormControlLabel
      control={
        <Checkbox
          className={className}
          onChange={onChange}
          name={name}
          checked={checked}
          sx={{ py: '3px', px: '9px' }}
        />
      }
      label={label}
    />
  </Box>
);

CustomCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default CustomCheckbox;
